import React, { useState } from 'react';
import { Redirect, Route, withRouter } from 'react-router';
import { CampfireSwitch } from '../../../content-blocks/common/CampfireSwitch';
import { Page } from '../../../global/components';
import { BulletinManagementScreen } from '../bulletin-management/BulletinManagementScreen';
import { CommunicationLogScreen } from './CommunicationLogScreen';
import { InboxScreen } from './InboxScreen';
import { CommunicationsTabsWrapper } from './CommunicationsTabsWrapper';
import { useAdvancedCommunicationsState } from './use-advanced-communications';

export const CommunicationsScreen = withRouter(({ match }) => {
  const { advanced: advancedCommunications, loading } = useAdvancedCommunicationsState();
  const [sentRefreshKey, setSentRefreshKey] = useState(0);
  const landingTab = advancedCommunications ? 'inbox' : 'bulletins';
  const onSent = () => setSentRefreshKey((key) => key + 1);
  const wrap = (children: React.ReactNode) => (
    <CommunicationsTabsWrapper onSent={onSent}>{children}</CommunicationsTabsWrapper>
  );

  // The tabs and landing route both depend on the tenant's package, so wait for it rather than guess.
  if (loading) return <Page />;

  return (
    <Page>
      <CampfireSwitch>
        <Route exact path={match.path} render={() => <Redirect to={`${match.path}/${landingTab}`} />} />
        <Route
          exact
          path={`${match.path}/inbox`}
          render={() => (advancedCommunications ? wrap(<InboxScreen />) : <Redirect to={`${match.path}/bulletins`} />)}
        />
        <Route
          exact
          path={`${match.path}/sent`}
          render={() =>
            wrap(
              <CommunicationLogScreen
                title='Sent'
                emptyTitle='Nothing sent yet'
                emptyDescription='Everything your organisation sends, across SMS and email, will show up here.'
                refreshKey={sentRefreshKey}
              />
            )
          }
        />
        <Route exact path={`${match.path}/bulletins`} render={() => wrap(<BulletinManagementScreen />)} />
      </CampfireSwitch>
    </Page>
  );
});
